export default __webpack_public_path__ + "static/media/picture-image.2e8485f6.svg";